import { render, staticRenderFns } from "./aidaAccount.vue?vue&type=template&id=6810962a&scoped=true&"
import script from "./aidaAccount.vue?vue&type=script&lang=js&"
export * from "./aidaAccount.vue?vue&type=script&lang=js&"
import style0 from "./aidaAccount.vue?vue&type=style&index=0&id=6810962a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810962a",
  null
  
)

export default component.exports